




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  name: "ForgotPasswordConfirm",
  components: {},
  directives: {},
})
export default class ForgotPasswordConfirm extends Vue {
  @Prop({ default: "" })
  email: string;

  public hide() {
    console.log("HIde");
    this.$emit("hide");
  }
}
